import React, { useState } from 'react';
import {
    useTheme,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Divider,
    Box,
    Grid,
    Typography,
} from '@mui/material';
import { tokens } from '../../theme/theme';
import { callApi } from '../../utils/apiClient';
import { API_ENDPOINTS } from '../../config/api/apiCall';


const WarehouseCreate = ({ open, onClose, terms, setTerms }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [viewAddNewWarehouse, setViewAddNewWarehouse] = useState(false);

    const [warehouseName, setWarehouseName] = useState('');
    const [location, setLocation] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [isPassed, setIspassed] = useState(false);



    const handleAddRow = () => {
        setViewAddNewWarehouse(true);
        GetWarehouseCode();

    };

    const handleSave = () => {
        // Save to API logic here
        console.log('Saved:', terms);
        insertWarehouseDetails();
        LoadWarehouseDetails();
        if (isPassed) { onClose(); }


    };

    const handleInputChange = (index, field, value) => {
        const newTerms = [...terms];
        newTerms[index][field] = value;
        setTerms(newTerms);
    };


    // get warehouse code to insert
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [warehouseCode, setWarehouseCode] = useState([]);
    const [warehouseID, setWarehouseID] = useState([]);

    const GetWarehouseCode = () => {
        const para = {
            p_companyid: 1,
        }

        callApi(API_ENDPOINTS.WAREHOUSE_GET_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setWarehouseCode(data[0].warehouse_code);
                }
            })
            .catch(error => {
                alert(error.message);
            });

    };


    const insertWarehouseDetails = () => {


        const requiredParameters = [
            { name: 'Warehouse code', value: warehouseCode },
            { name: 'Warehouse Name', value: warehouseName },
            { name: 'Location', value: location },
            { name: 'Email', value: email, validate: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) },
            { name: 'Work Phone', value: phone, validate: (value) => /^\+?[0-9]{7,15}$/.test(value) },
        ];

        const missingParameter = requiredParameters.find(param =>
            param.value === null ||
            param.value === undefined ||
            param.value === '' ||
            (param.validate && !param.validate(param.value))
        );

        if (missingParameter) {
            setIspassed(false);
            alert(`Please provide a valid value for ${missingParameter.name}.`);
            return;
        }


        const parameter = {
            p_companyid: 1,
            p_warehouse_code: warehouseCode,
            p_warehouse_name: warehouseName,
            p_warehouse_location: location,
            p_email_address: email,
            p_phone_number: phone,

        }

        callApi(API_ENDPOINTS.WAREHOUSE_INSERT_DETAILS, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    setWarehouseID(data[0].id_warehouse);
                    alert('New Warehouse created successfully');
                    setIspassed(true);
                }
            })
            .catch(error => {
                alert(error.message);
            });

    };

    const LoadWarehouseDetails = () => {
        const para = {
            p_companyid: 1,
        }

        callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setTerms(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });

    }







    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >
            <DialogTitle style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                Add Warehouse
            </DialogTitle>
            <Divider />
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>

                <Box
                    gridColumn="span 9"
                    gridRow={"span 2"}
                    alignItems="center"
                    justifyContent="center"

                    padding={1}
                    sx={{
                        "& .MuiTable-root": {
                            border: "none",
                            borderRadius: "10px",
                            size: "small",
                        },
                        "& .MuiTableCell-root": {
                            borderBottom: "none",
                            // fontWeight: "bold",
                            border: "1px solid ",
                            borderRadius: "10px",
                            borderColor: `${colors.primary[400]} !important`,
                        },
                        "& .name-column--cell": {
                            color: colors.greenAccent[300],
                        },
                        "& .MuiTableHead-root": {
                            // backgroundColor: colors.blueAccent[700],
                            borderBottom: "none",
                            borderRadius: "10px",

                        },
                        "& .MuiTableBody-root": {
                            overflowY: "auto",
                        },
                        "& .MuiCheckbox-root": {
                            color: `${colors.blueAccent[200]} !important`,
                            size: "small",
                        },
                        "& .MuiTableFooter-root": {
                            borderTop: "none",
                            height: "10px",
                        },
                        "& .MuiButton-text": {
                            color: `${colors.grey[100]} !important`,
                        },

                    }}>



                    <TableContainer >
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ color: colors.primary }}>Warehouse Name</TableCell>
                                    <TableCell style={{ color: colors.primary }}>Location</TableCell>
                                    <TableCell style={{ color: colors.primary }}>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {terms.map((term, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <TextField
                                                value={term.description}
                                                onChange={(e) => handleInputChange(index, 'description', e.target.value)}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '8px',
                                                        textAlign: 'left',
                                                    },
                                                }}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                style={{ color: colors.primary }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={term.location}
                                                onChange={(e) => handleInputChange(index, 'location', e.target.value)}
                                                variant="outlined"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '8px',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                size="small"
                                                fullWidth
                                                style={{ color: colors.primary }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={term.status}
                                                onChange={(e) => handleInputChange(index, 'status', e.target.value)}
                                                variant="outlined"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '8px',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                size="small"
                                                fullWidth
                                                style={{ color: colors.primary }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>


                    <Button size='small' variant="contained" onClick={handleAddRow} color="secondary" style={{ marginTop: '10px' }}>
                        {/*   */}
                        Add New Warehouse
                    </Button>
                </Box>

                {/* <Box
                    gridColumn="span 9"
                    gridRow={"span 2"}
                    alignItems="center"
                    justifyContent="center"
                    padding={1}
                    sx={{
                        "& .MuiTable-root": {
                            border: "none",
                            borderRadius: "10px",
                            size: "small",
                        },
                        "& .MuiTableCell-root": {
                            borderBottom: "none",
                            border: "1px solid",
                            borderRadius: "10px",
                            borderColor: `${colors.primary[400]} !important`,
                            padding: 0, // Removes padding within table cells
                        },
                        "& .name-column--cell": {
                            color: colors.greenAccent[300],
                        },
                        "& .MuiTableHead-root": {
                            borderBottom: "none",
                            borderRadius: "10px",
                        },
                        "& .MuiTableBody-root": {
                            overflowY: "auto",
                        },
                        "& .MuiCheckbox-root": {
                            color: `${colors.blueAccent[200]} !important`,
                            size: "small",
                        },
                        "& .MuiTableFooter-root": {
                            borderTop: "none",
                            height: "10px",
                        },
                        "& .MuiButton-text": {
                            color: `${colors.grey[100]} !important`,
                        },
                    }}
                >
                    <TableContainer sx={{ borderRadius: "10px", overflow: "hidden" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ color: colors.primary, textAlign: 'center' }}>Terms Name</TableCell>
                                    <TableCell style={{ color: colors.primary, textAlign: 'center' }}>Number of Days</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {terms.map((term, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <TextField
                                                value={term.tdescription}
                                                onChange={(e) => handleInputChange(index, 'tdescription', e.target.value)}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '8px',
                                                        textAlign: 'left',
                                                    },
                                                }}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                style={{ color: colors.primary }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                type='number'
                                                value={term.tdays}
                                                onChange={(e) => handleInputChange(index, 'tdays', e.target.value)}
                                                variant="outlined"
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '8px',
                                                        textAlign: 'right',
                                                    },
                                                }}
                                                size="small"
                                                fullWidth
                                                style={{ color: colors.primary }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Button
                        size="small"
                        variant="standard"
                        color="secondary"
                        startIcon={<AddCircleOutline sx={{ color: colors.blueAccent[400] }} />}
                        onClick={handleAddRow}
                        style={{ marginTop: '10px', textTransform: 'none' }}
                    >
                        Add New Term
                    </Button>

                    




                </Box> */}
                {viewAddNewWarehouse && (
                    <Grid container  >
                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontWeight="bold"> Warehouse Code</Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        // label="Zone"
                                        variant="outlined"
                                        value={warehouseCode}
                                        // onChange={(e) => setZone(e.target.value)}
                                        required
                                    />
                                </Grid>

                            </Grid>

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontWeight="bold"> Warehouse Name </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        // label="Zone"
                                        variant="outlined"
                                        value={warehouseName}
                                        onChange={(e) => setWarehouseName(e.target.value)}
                                        required
                                    />
                                </Grid>
                            </Grid>

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontWeight="bold">  Location </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        // label="Zone"
                                        variant="outlined"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        required
                                    />
                                </Grid>
                            </Grid>

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontWeight="bold"> Email </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        // label="Zone"
                                        variant="outlined"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </Grid>

                            </Grid>

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontWeight="bold"> Phone </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        // label="Zone"
                                        variant="outlined"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        required
                                    />
                                </Grid>
                            </Grid>


                        </Grid>
                    </Grid>
                )}
            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Button size='small' variant="contained" color="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button size='small' variant="contained" color="secondary" onClick={handleSave}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarehouseCreate;